import { Icon } from '@ds/core';
import { s } from '../classes';
import { Dialogo, DialogoCabecalho, DialogoCorpo, DialogoRodape } from '../ui/camadas';

/* A conversa por voz em si é a tela cheia `ModoDeVoz` (B9, 13/09/2026); o cartãozinho no canto
   do chat saiu. Aqui fica só o aviso de requisitos, antes da primeira vez. */

/* ---------------------------------------------------- aviso de requisitos */

const REQUISITOS = [
    { icone: 'key-round', titulo: 'Chave de IA ligada na plataforma', dica: 'A transcrição da sua fala usa a OpenAI ou o Gemini; a voz da VecchIA é a Gacrux, do Gemini, com a OpenAI de reserva.' },
    { icone: 'cpu', titulo: 'Teto de IA da clínica', dica: 'Cada fala transcrita e cada resposta em voz contam no teto do mês.' },
    { icone: 'mic', titulo: 'Microfone permitido', dica: 'Autorize o acesso no navegador e confira se o orbe reage quando você fala. Recomendado: Chrome ou Edge.' },
    { icone: 'volume-2', titulo: 'Resposta em voz', dica: 'Verifique o volume do aparelho. Sem a voz do servidor, fala a voz do navegador.' },
];

export interface AvisoDaVozProps {
    aberto: boolean;
    aoFechar: () => void;
    aoContinuar: () => void;
}

/** `BrainVoiceIntroDialog`: o que a conversa por voz precisa, antes da primeira vez. */
export function AvisoDaVoz({ aberto, aoFechar, aoContinuar }: AvisoDaVozProps) {
    return (
        <Dialogo aberto={aberto} aoFechar={aoFechar} rotulo="Conversa por voz" tamanho="md">
            <DialogoCabecalho>
                <h2 className={s.dialogTitle}>
                    <Icon name="audio-lines" size={18} />
                    Conversa por voz
                </h2>
                <p className={s.dialogLead}>
                    A VecchIA — assistente generativa que pode fazer praticamente tudo para sua clínica — ouve você, consulta a
                    clínica e responde em áudio, como numa conversa. Pode falar por cima para interromper. Quando ela propõe uma
                    ação, os dados aparecem num cartão e nada acontece até você confirmar — tocando em Confirmar ou dizendo “pode”.
                </p>
            </DialogoCabecalho>
            <DialogoCorpo>
                <div className="brain-sub__notice">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
                        <Icon name="info" size={13} />
                        Requisitos para utilizar
                    </div>
                    {REQUISITOS.map((r) => (
                        <div key={r.titulo} className="brain-sub__req-item">
                            <div className="brain-sub__req-icon"><Icon name={r.icone} size={14} /></div>
                            <div>
                                <div style={{ fontSize: 12.5, lineHeight: 1.45 }}>{r.titulo}</div>
                                <div style={{ fontSize: 12, color: 'var(--brain-text-secondary)', marginTop: 2 }}>{r.dica}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <p style={{ fontSize: 12, color: 'var(--brain-text-secondary)', lineHeight: 1.45 }}>
                    Sem chave de transcrição, não é possível entender a sua fala. O chat por texto e os demais recursos da
                    VecchIA continuam disponíveis normalmente.
                </p>
            </DialogoCorpo>
            <DialogoRodape>
                <button type="button" className={s.btnGhost} onClick={aoFechar}>Cancelar</button>
                <button type="button" className={s.btnPrimary} onClick={() => { aoFechar(); aoContinuar(); }}>Entendi, iniciar</button>
            </DialogoRodape>
        </Dialogo>
    );
}
